export const validateEmptyValue = <T>(value: T): T | undefined => {
  if ((typeof value === 'string' && value !== '') || typeof value === 'number' && value > 0) {
    return value
  }

  return undefined
}